import React from 'react';
import AudioPlayer from './AudioPlayer';
import { featuredMixes } from '../mock';
import Header from './Header';
import Footer from './Footer';

const SampleMixesPage = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      
      {/* Audio Player Section - No title, just the player */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <AudioPlayer tracks={featuredMixes} />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SampleMixesPage;